
export default {
  components: {},
  props: {
    pixData: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    copy(item) {
      try {
        navigator.clipboard.writeText(item)
        this.$toast.success('Copiado com sucesso')
      } catch (err) {
        this.$toast.error('Opa, houve um erro: ' + err)
      }
    },
  },
}
